module.exports = __webpack_public_path__ + "images/home/index/templates-product-48d978e31a332f58e906d1d02e8030ae.png";